(function () {
    'use strict';

    angular.module('app.reviews', [
        // Angular modules
        'ngRoute',

        // Custom modules
        'treeControl'
        // 3rd Party Modules

    ]);
})();